import Vue from "vue";
import VueI18n from "vue-i18n";
import { getSupportedLocales } from "@/helpers";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function normalizeLocale(locale) {
  if (!locale) {
    return locale;
  }

  const normalizedLocale = locale.toString().trim().replace("_", "-").toLowerCase();
  if (!normalizedLocale) {
    return locale;
  }

  if (normalizedLocale === "be") {
    return "nl-be";
  }

  // Map generic English (or an English regional code) to the existing en-GB locale file.
  if (normalizedLocale === "en" || normalizedLocale.startsWith("en-")) {
    return "en-GB";
  }

  return locale;
}

function getLocale() {
  // Check if language in localStorage
  if (!localStorage.getItem("locale")) {
    // Check if is browser language is supported
    let supported = false;
    getSupportedLocales().forEach(locale => {
      if (navigator.language.toLocaleLowerCase().includes(locale.toLowerCase())) {
        localStorage.setItem("locale", locale);
        supported = true;
      }
    });

    // No support => go to default
    if (!supported) {
      const defaultLocale = normalizeLocale(process.env.VUE_APP_I18N_LOCALE);
      localStorage.setItem("locale", defaultLocale);
      return defaultLocale;
    }
  }

  const normalizedLocale = normalizeLocale(localStorage.getItem("locale"));
  if (normalizedLocale !== localStorage.getItem("locale")) {
    localStorage.setItem("locale", normalizedLocale);
  }

  return normalizedLocale;
}

const fallbackLocale = normalizeLocale(process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en");

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: fallbackLocale,
  messages: loadLocaleMessages()
});
